import React, { useState } from "react";
import LazyLoad from "react-lazyload";
import CountdownTimer from "../../../components/Countdown/CountdownTimer";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledCtaText from "../../../common/components/styledCtaText/StyledCtaText";
import GradientButton from "../../../components/Buttons/GradientButton/GradientButton";
import StyledH1Heading from "../../../common/components/styledH1Heading/StyledH1Heading";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import EarlyAccessModal from "../../../components/Modals/EarlyAccessModal/EarlyAccessModal";
import { useDateFormate } from "../../../utils/useDateFormate";

const HeroSection = () => {
  const [EarlyAccess, setEarlyAccess] = useState(false);
  const [hoveredImage, setHoveredImage] = useState("/assets/golden-collection-2.svg");
  const fixedLaunchDate = new Date("2025-02-21T00:00:00Z");

  const today = new Date();
  today.setSeconds(0, 0);

  const isLaunchDatePassed = today >= fixedLaunchDate;
  const formattedLaunchDate = useDateFormate?.(fixedLaunchDate);

  const handleMouseEnter = (imageSrc) => setHoveredImage(imageSrc);
  
  const renderHoverImage = (src, alt, index) => (
    <div
      key={index}
      className="flex flex-col justify-center items-center w-fit gap-5"
      onMouseEnter={() => handleMouseEnter(src)}
    >
      <LazyLoad>
        <img src={src} alt={alt} loading="lazy" />
      </LazyLoad>
      <StyledH6Heading>{alt}</StyledH6Heading>
    </div>
  );

  const handleButtonClick = () => {
    setEarlyAccess(true);
  };

  const imageData = [
    { src: "/assets/golden-collection-1.svg", alt: "Golden Ball" },
    { src: "/assets/golden-collection-2.svg", alt: "Gold Rubiks Cube" },
    { src: "/assets/golden-collection-3.svg", alt: "Rubber Duck" },
  ];

  return (
    <div className={`w-full ${isLaunchDatePassed ? "xl:pb-0 xl:py-32 py-32" : "-mt-[90px] pt-32"} flex justify-center items-center CollectionBg`}>
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex flex-col xl:flex-row gap-20 justify-between items-start xl:items-end">
        <div className={`w-full lg:w-[70%] xl:w-[40%] flex flex-col justify-center items-center gap-8 ${isLaunchDatePassed ? "self-center" : "pb-10"}`}>
          <div className="flex flex-col justify-center gap-1">
            <StyledH5Heading fontColor="capitalize">Let’s begin with our</StyledH5Heading>
            <StyledH1Heading fontColor="textGradient">Golden Collection</StyledH1Heading>
            <StyledMdText>
              We have a huge collection of premium gold NFT’s made with love for our valuable customers
            </StyledMdText>
          </div>
          {!isLaunchDatePassed && (
            <div className="LeftSideContainer yellow-border px-5 md:px-10 lg:px-5 py-5 flex flex-col justify-center gap-4 w-full sm:w-4/5 lg:w-full">
              <div className="flex justify-start gap-3 sm:gap-7 launch-date flex-wrap">
                <StyledH5Heading>Launch Date</StyledH5Heading>
                <StyledCtaText fontColor="text-bright-yellow border border-bright-yellow h-fit px-6 py-1 rounded-[4px] text-nowrap">
                  {formattedLaunchDate}
                </StyledCtaText>
              </div>
              <div>
                <CountdownTimer launchdate={fixedLaunchDate} />
              </div>
              <hr className="w-full h-[1px] bg-white" />
              <div className="text-center space-y-3">
                <StyledH6Heading>Secure your Slot</StyledH6Heading>
                <div>
                  <GradientButton onClick={handleButtonClick} fontColor="w-full">
                    Remind Me!
                  </GradientButton>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={`relative hidden w-full md:w-[55%] pt-[18%] ${isLaunchDatePassed ? "2xl:mt-[2%]" : "2xl:mt-[10%]"} backdrop-blur ratingGradient border-t border-x rounded-t-[18px] xl:flex justify-center items-end px-5 xl:px-16 pb-5`}>
          <div className="absolute -top-[30%] xl:-top-[30%] xl:right-[30%]">
            {hoveredImage && <img src={hoveredImage} alt="" loading="lazy" className="w-52 xl:w-64" />}
          </div>
          <div className="flex justify-between items-end w-full h-fit cursor-pointer">
            {imageData?.map((image, index) => renderHoverImage(image.src, image.alt, index))}
          </div>
        </div>
      </div>
      {EarlyAccess && <EarlyAccessModal closeModal={() => setEarlyAccess(false)} />}
    </div>
  );
};

export default HeroSection;